module.exports = __webpack_public_path__ + "img/23.32dd0f41.jpg";